import { Hero, Services, About, Quote, Contact } from '@/features/marketing';

export function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Quote />
      <Contact />
    </>
  );
}
